import * as React from 'react';

import { IStationModel } from '../../../store/stations';
import { DEFAULT_STATION_GROUPS } from '../../../utils/stations';
import { trackRailwayGroupSelected, trackRailwayPartSelected } from '../tracking';
import { TStationListProps } from './container';
import { StationGroup } from './group';
import { isEmpty } from '../../../utils/isEmpty';

import * as styles from './StationList.css';

const LETTER_TITLE_HEIGHT = 20;

export class StationList extends React.Component<TStationListProps> {
  public render() {
    const { groupedStations } = this.props;

    if (isEmpty(groupedStations)) {
      return null;
    }

    return (
      <div className={styles['list']}>
        {this.columns.map((column, index) => (
          <div key={`${index}_${column}`} className={styles['list-column']}>
            {column.map(key => (
              <StationGroup
                key={key}
                groupIndex={+key}
                {...this.props}
                changeStationGroup={this.changeStationGroup(+key)}
                getAvailableStations={this.getAvailableStations}
                onStationValueChange={this.onStationValueChange(+key)}
              />
            ))}
          </div>
        ))}
      </div>
    );
  }

  private get columns() {
    const { groupedStations } = this.props;
    const keys = Object.keys(groupedStations);

    return keys.length <= 4 ? keys.map(key => [key]) : this.altSortRegions([[], [], [], keys]);
  }

  private getAvailableStations = (stations: IStationModel[] = []) =>
    stations.reduce(
      (acc, station) => (this.isStationEnabled(station.id) ? acc.concat(station) : acc),
      [] as IStationModel[],
    );

  private isStationEnabled = (id: number) => {
    const { stationDistance } = this.props;
    const stationData = this.props.stationData as Record<number, number>;

    return id in stationData && stationData[id] <= stationDistance;
  };

  private onStationValueChange =
    (groupIndex: number) =>
    (id: number, name: string, checked = true) => {
      this.props.onChangeSelectedStations([id], checked);
      trackRailwayPartSelected(`${name}/${DEFAULT_STATION_GROUPS[groupIndex]}`);
    };

  private changeStationGroup = (groupIndex: number) => (checked: boolean, stations: IStationModel[]) => {
    this.props.onChangeSelectedStations(
      stations.map(({ id }) => id),
      checked,
    );

    if (checked) {
      trackRailwayGroupSelected(DEFAULT_STATION_GROUPS[groupIndex]);
    }
  };

  private getColumnLength(keys: string[]) {
    return keys.reduce((acc, key) => acc + this.props.groupedStations[+key].length, keys.length * LETTER_TITLE_HEIGHT);
  }

  private moveColumns(left: string[], right: string[]) {
    const leftCount = this.getColumnLength(left);
    const rightCount = this.getColumnLength(right);

    if (leftCount <= rightCount && rightCount - leftCount > LETTER_TITLE_HEIGHT) {
      const group = right.shift();
      if (group) {
        left.push(group);
      }

      return true;
    }

    return false;
  }

  private altSortRegions(initialColumns: string[][]): string[][] {
    const columns: string[][] = initialColumns;

    let isMoved = false;

    isMoved = this.moveColumns(columns[2], columns[3]) || isMoved;
    isMoved = this.moveColumns(columns[1], columns[2]) || isMoved;
    isMoved = this.moveColumns(columns[0], columns[1]) || isMoved;

    if (isMoved) {
      return this.altSortRegions(columns);
    }

    return columns;
  }
}
